import { useRouteLoaderData } from '@remix-run/react';

import type { loader as communityLoader } from '~/routes/community';

export const useMemberBlockingEnabled = (): boolean => {
  const layoutData = useRouteLoaderData<typeof communityLoader>('routes/community');
  return Boolean(layoutData?.community?.member_blocking_enabled);
};
